<ng-container *ngIf="presenceStatus$ | async as presenceStatus">
   <fa-icon
      [ngClass]="presenceStatus.presenceStatus.styleClass"
      [icon]="presenceStatus.presenceStatus.statusIcon"
      kendoTooltip
      [title]="presenceStatus?.presenceStatus.translationKey | translate"
      [fixedWidth]="fixedWidth"
   ></fa-icon>
   <span [ngClass]="presenceStatus.presenceStatus.styleClass">
      {{ presenceStateText$ | async }}
   </span>
</ng-container>
<ng-container *ngIf="!(presenceStatus$ | async) as presenceStatus">
   <fa-icon
      [ngClass]="presenceStatus.presenceStatus.styleClass"
      [icon]="presenceStatus.presenceStatus.statusIcon"
      kendoTooltip
      [title]="presenceStatus?.presenceStatus.translationKey | translate"
      [fixedWidth]="fixedWidth"
   ></fa-icon>
</ng-container>
<ng-container *ngIf="lastActiveField$ | async">
   -
   {{ lastActiveField$ | amTimeInThePastUpdateEveryMinute$ | singleUnitDurationToText$ | async }}
   {{ lastActiveField$ | amTimeInThePastUpdateEveryMinute$ | singleTimeUnit$ | async | translate }}
</ng-container>
